<template>
  <v-ons-page>
    <div class="background" />

    <img
      class="home-menu_close"
      src="~@/assets/images/close_button.svg"
      @click="hideMenu"
    >
    <div class="content">
      <nav class="home-menu">
        <ul>
          <li class="primary">
            <a class="label" href="./home.html">
              ホーム
            </a>
          </li>
          <!-- NOTE: ネストしているメニューのサンプル -->
          <!--
          <li class="primary">
            <span class="label">
              Contents 1
            </span>
            <ul>
              <li class="secondary">
                <a class="label">
                  Sub Contents 1
                </a>
              </li>
              <li class="secondary">
                <a class="label">
                  Sub Contents 2
                </a>
              </li>
            </ul>
          </li>
          -->
        </ul>
      </nav>
    </div>

    <!-- NOTE: 社内向けメニュー -->
    <v-ons-row class="private-menu">
      <v-ons-col
        class="private-menu_1"
        @click="goToPrivateMenu"
      />
      <v-ons-col class="private-menu_2" />
      <v-ons-col class="private-menu_3" />
    </v-ons-row>
  </v-ons-page>
</template>

<script>
import privateMenu from '@/components/private/index.vue';

export default {
  methods: {
    hideMenu() {
      this.$store.commit('homeNavigator/toggleMenu', false);
    },
    goToPrivateMenu() {
      this.$store.commit('appNavigator/push', privateMenu);
    },
  },
};
</script>

<style scoped lang="scss">
.background {
  background: #fff;
}
.content {
  top: 160px;
  padding-bottom: 48px;

}
.home {
  &-menu {
    padding: 0 60px;
  }
  &-menu_close {
    position: absolute;
    top: 40px;
    right: 40px;
    z-index: 10;
    text-align: right;
    img {
      vertical-align: bottom;
    }
  }
}
ul {
  margin: 0;
  padding: 0;
}
li {
  display: block;
  font-size: 24px;

  &.primary {
    border-top: 2px solid #707070;
    &:last-child {
      border-bottom: 2px solid #707070;
    }
  }
  &.secondary {
    border-top: 1px dotted #c7c7c7;
    padding: 0 20px;
  }
}
.label {
  display: block;
  padding: 20px 0;
}
a.label {
  background-image: url('~@/assets/images/icon_arrow.svg');
  background-repeat: no-repeat;
  background-position: top 50% right 20px;
  text-decoration: none;
  color: inherit;
}
.private {
  &-menu {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 8px;
    width: 100%;
  }
  &-menu_1 {
    background: #002f7b;
  }
  &-menu_2 {
    background: #00ab84;
  }
  &-menu_3 {
    background: #ed6d46;
  }
}
</style>



// WEBPACK FOOTER //
// menu.vue?3d4db9ff